export default __webpack_public_path__ + "static/media/ai_virtual_services_ai_photos_en.b425b4b9.png";